export default __webpack_public_path__ + "static/media/squirrel.1605ca1e.png";